export default __webpack_public_path__ + "static/hire-d55161c9d968fc87f0c192076fa1cbc9.png";